import * as tslib_1 from "tslib";
import { EventEmitter, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { AutoUnsubscribe } from '../../../../../../../core/decorators/auto-unsubscribe';
import { CustomerDeleteService } from '../../servicios/customer-delete.service';
let DeleteCustomerModalComponent = class DeleteCustomerModalComponent {
    constructor(_customerDeleteService, translateService, toastr) {
        this._customerDeleteService = _customerDeleteService;
        this.translateService = translateService;
        this.toastr = toastr;
        this.modalClose = new EventEmitter();
    }
    ngOnInit() { }
    closeModal(conDatos) {
        if (conDatos) {
            const parametros_In = {
                deleteId: this.dataCustomer.CustomerId
            };
            this.deactivarSubscription = this._customerDeleteService.post(JSON.stringify(parametros_In))
                .subscribe(data => {
                const auxdata = data.Response;
                if (auxdata) {
                    if (auxdata.Data) {
                        this.translateService.get('genericos.toastr.successfulDelete').subscribe(text => {
                            this.toastr.success(text);
                            this.modalClose.emit(auxdata.Data);
                        });
                    }
                    else {
                        this.translateService.get('genericos.toastr.imposibleborrar').subscribe(res => {
                            this.toastr.error(res);
                        });
                        this.modalClose.emit('cerrar');
                    }
                }
                else {
                    this.error = data.Warning.Content;
                    this.code = data.Warning.Title;
                    this.translateService.get('genericos.toastr.imposibleborrar').subscribe(res => {
                        this.toastr.error(res);
                    });
                    this.modalClose.emit('cerrar');
                }
            });
        }
        else {
            this.modalClose.emit('cerrar');
        }
    }
};
DeleteCustomerModalComponent = tslib_1.__decorate([
    AutoUnsubscribe(),
    tslib_1.__metadata("design:paramtypes", [CustomerDeleteService,
        TranslateService,
        ToastrService])
], DeleteCustomerModalComponent);
export { DeleteCustomerModalComponent };
